import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as changeImpact from '../change-impact'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: changeImpact.RESOURCE.payload.dimension.partialId,
      partialId: changeImpact.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Key benefit for this change impact.',
    isOptional: true,
    name: 'Key Benefit',
    partialId: PartialId.Standard.create('key_benefit'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
